import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

type Passenger = {
    id: number | null;
    name: string | null;
    contactNumber: string | null;
    email: string | null;
    address: string | null;
    age: number | null;
    gender: string | null;
    orgId: number | null;
    orgName: string | null;
    passengerStatusQuestions: string[] | null;
    updatedAt: string | null;
  };

type QuestionList = {
    id: number | null;
    question: string;
}

export class PassengerDetailStore {
    passengerDetail: Passenger = {
        id: null,
        name: "",
        contactNumber: "",
        email: "",
        address: "",
        age: null,
        gender: "",
        orgId: null,
        orgName: "",
        passengerStatusQuestions: [],
        updatedAt: ""
      };
    croniDisease: string = "";
    impaired: string = "";
    questionList: QuestionList[] = [];
    roleName: string = "";


    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore
        }

    setPassenger = (detail: Passenger) => {
        this.passengerDetail = detail;
        }
    get getPassenegr() {
        return this.passengerDetail;
        }

    setCroniDisease = (disease: string) => {
        this.croniDisease = disease;
        }
    get getCroniDisease() {
        return this.croniDisease;
        }

    setImpaired = (disease: string) => {
        this.impaired = disease;
        }
    get getImpaired() {
        return this.impaired;
        }
    
    setQuestionList = (list: QuestionList[]) => {
        this.questionList = list;
        }
    get getQuestionList() {
        return this.questionList;
        }

    setRolename = (rolename: string) => {
        this.roleName = rolename;
        }
    get getRoleName() {
        return this.roleName;
        }
}